import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ArchiveComponent, BugReportsComponent, DealerComponent, FinanceComponent, FormServerComponent, ImportReportComponent, IncentivesComponent, InsuranceProductsComponent, LeaseResidualsComponent, MenuLinksComponent, SettingsMenuComponent } from "./pages";
import { AccessoryFormComponent, CertUsedResidualsTableComponent, FeaturedAccessoriesComponent, FeaturedAccessoryComponent, FinanceDefaultFormComponent, FinanceRatesFormComponent, IncentiveFormComponent, IncentiveGroupComponent, IncentiveGroupListComponent, InsuranceProductFormComponent, InsuranceProductListComponent, LeaseDefaultFormComponent, MenuLinkDisplayComponent, MenuLinkFormComponent, MenuLinkListComponent, NewResidualsTableComponent, UploadCertUsedResidualsComponent, UploadNewResidualsComponent, EthosImportLogsComponent, ResidualImporterComponent } from "./components";
import { SettingsRoutingModule } from "./settings.routing.module";
import { NgbCollapseModule, NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { SharedModule } from "../shared-module/shared.module";
import { MatDialogModule } from "@angular/material/dialog";
import { MatTableModule } from "@angular/material/table";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSortModule } from "@angular/material/sort";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { NgxJsonViewerModule } from "ngx-json-viewer";

@NgModule({
  declarations: [
    SettingsMenuComponent,
    MenuLinksComponent,
    MenuLinkFormComponent,
    AccessoryFormComponent,
    DealerComponent,
    FinanceComponent,
    FinanceDefaultFormComponent,
    FinanceRatesFormComponent,
    InsuranceProductFormComponent,
    InsuranceProductListComponent,
    InsuranceProductsComponent,
    SettingsMenuComponent,
    FeaturedAccessoryComponent,
    FeaturedAccessoriesComponent,
    LeaseDefaultFormComponent,
    LeaseResidualsComponent,
    MenuLinkDisplayComponent,
    MenuLinkListComponent,
    UploadNewResidualsComponent,
    UploadCertUsedResidualsComponent,
    NewResidualsTableComponent,
    CertUsedResidualsTableComponent,
    ResidualImporterComponent,
    IncentivesComponent,
    IncentiveGroupComponent,
    IncentiveFormComponent,
    IncentiveGroupListComponent,
    ArchiveComponent,
    FormServerComponent,
    EthosImportLogsComponent,
    BugReportsComponent,
    ImportReportComponent
  ],
  imports: [
    NgbModule,
    NgbCollapseModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    SettingsRoutingModule,
    SharedModule,
    MatDialogModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatIconModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    NgxJsonViewerModule
  ]
})
export class SettingsModule {}
